<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">己内酰胺</span> > 价格</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>价格</p>
        <div class="btn fr" @click="search">搜索</div>
<!--        <el-date-picker-->
<!--            class="fr"-->
<!--            size="small"-->
<!--            v-model="endTime"-->
<!--            align="right"-->
<!--            type="date"-->
<!--            style="width: 150px"-->
<!--            placeholder="选择结束日期"-->
<!--            format="yyyy-MM-dd"-->
<!--            value-format="yyyy-MM-dd"-->
<!--        >-->
<!--        </el-date-picker>-->
<!--        <el-date-picker-->
<!--            class="fr"-->
<!--            size="small"-->
<!--            v-model="startTime"-->
<!--            style="width: 150px"-->
<!--            format="yyyy-MM-dd"-->
<!--            value-format="yyyy-MM-dd"-->
<!--            align="right"-->
<!--            type="date"-->
<!--            placeholder="选择开始日期"-->
<!--        >-->
<!--        </el-date-picker>-->
        <input class="fr" v-model="likeTitleName" type="text" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs('issue_caprolactam_east_price')"
             :class="{'hover':flag === 'issue_caprolactam_east_price'}">华东价格
        </div>
        <div @click="changeTabs('issue_caprolactam_exit_price')"
             :class="{'hover':flag === 'issue_caprolactam_exit_price'}">进出口价格
        </div>
        <div @click="changeTabs('32')" :class="{'hover':flag === '32'}">挂牌/结算价格</div>
<!--        <div @click="changeTabs('33')" :class="{'hover':flag === '33'}">结算价格</div>-->
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="goDetail(item.completeOriginalDate)" v-if="flag === 'issue_caprolactam_east_price' || flag === 'issue_caprolactam_exit_price'">
            {{
              item.date + '己内酰胺' + (flag === 'issue_caprolactam_east_price' ? '华东价格' : '进出口价格')
            }}</p>
          <p v-else @click="goDetail(item.id)">
            {{item.titleName}}
          </p>
          <span v-if="flag === 'issue_caprolactam_east_price' || flag === 'issue_caprolactam_exit_price'" class="fr">{{ item.completeOriginalDate }}</span>
          <span v-else class="fr">{{ item.showYearTime }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="size"
          :current-page="page"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  priceList,
  backPriceList
} from '@/api/caprolactam'

export default {
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      size: 15,
      flag: 'issue_caprolactam_east_price',
      likeTitleName: '',
      startTime:'',
      endTime:''
    }
  },
  created() {
    if (this.$route.query && this.$route.query.flag) {
      this.flag = this.$route.query.flag
    }
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      this.list = [];
      const fn = (this.flag === 'issue_caprolactam_east_price' || this.flag === 'issue_caprolactam_exit_price') ? priceList({
        pageNum: this.page,
        pageSize: this.size,
        dictDataType: this.flag,
        dataType: 1
      }) : backPriceList({pageNum: this.page, pageSize: this.size, sourceType: this.flag, likeTitleName: this.likeTitleName});
      fn.then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    /**
     * 搜索
     */
    search() {
      this.page = 1;
      this.getList()
    },
    /**
     * 前往详情页
     */
    goDetail(id) {
      if (this.flag === '32') {
        this.$router.push({path: `/caprolactam/backPrice`, query: {id: id, flag: this.flag}})
      } else {
        this.$router.push({path: `/caprolactam/price`, query: {id: id, flag: this.flag}})
      }
    },
    /**
     * 切换tabs
     */
    changeTabs(flag) {
      this.flag = flag;
      this.page = 1;
      this.getList();
    },
    /**
     * 回退
     */
    back() {
      this.$router.push({path:'/caprolactam'})
    },
    /**
     * 分页
     */
    goFirst() {
      this.page = 1;
      this.getList()
    },
    goLast() {
      this.page = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.page = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
